import { APP_SWITCH_APPEARANCE } from '../Plugins/AppSwitchAppearance';
import { APP_COMPANY_CONFIG } from '../_Company/AppCompanyConfig';
import { GET_ACTIVE_LOGO } from '../_Company/_GetLogo';

/*
    ========================================================================
    BRAND SLOTS - CONFIGURACION PURA Y SIN DEPENDENCIAS DE ROUTING
    ========================================================================

    Este archivo existe para que TODOS los logos lean el mismo bloque:

        Plugins/AppSwitchAppearance.js -> BRAND

    sin importar AppShell.Layout.js desde componentes visuales.

    IMPORTANTE:
    AppShell.Layout.js importa AppModules para construir las rutas. A su vez,
    AppModules termina importando vistas publicas, y esas vistas usan BrandLogo.
    Si BrandLogo importa AppShell.Layout.js se forma este ciclo:

        AppShell.Layout -> AppModules -> Vista -> BrandLogo -> AppShell.Layout

    y Webpack puede lanzar:
        "Cannot access 'APP_MODULES_GET_PUBLIC_ROUTES' before initialization".

    Por eso este modulo SOLO depende de configuracion pura de marca/empresa.
    No conoce rutas, vistas, layout ni modulos.
*/

const LOGO_BASE = {
    id: 'base',
    assets: {
        light: APP_COMPANY_CONFIG.COMPANY_IMGS.BRAND_LIGHT,
        dark: APP_COMPANY_CONFIG.COMPANY_IMGS.BRAND_DARK,
    },
};

const BRAND_HEIGHT_BY_APPEARANCE = ['40px', '28px', '52px', '64px', '34px'];

const onResolveBrandObjectPosition = (appearance = 1) => {
    const LEVEL = Math.min(25, Math.max(1, Number(appearance) || 1));

    if (LEVEL <= 5) return 'left center';
    if (LEVEL <= 10) return 'center';
    if (LEVEL <= 15) return 'right center';
    if (LEVEL <= 20) return 'center top';

    return 'center bottom';
};

const onResolveBrandHeight = (config = {}) => {
    if (config.height && config.height !== 'auto') return config.height;

    const LEVEL = Math.min(25, Math.max(1, Number(config.appearance) || 1));
    return BRAND_HEIGHT_BY_APPEARANCE[(LEVEL - 1) % 5];
};

export const onBuildBrandSlot = (config = {}) => {
    const LOGO = config.isCelebrate === true ? GET_ACTIVE_LOGO() : LOGO_BASE;
    const IS_LOGO = config.isLogo === true;

    return {
        isLogo: IS_LOGO,
        logoId: LOGO.id,
        logoLight: IS_LOGO ? LOGO.assets.light : null,
        logoDark: IS_LOGO ? LOGO.assets.dark : null,
        appearance: config.appearance,
        width: config.width,
        height: config.height,
        imageStyle: {
            width: config.width && config.width !== 'auto' ? config.width : 'auto',
            height: onResolveBrandHeight(config),
            maxWidth: 'none',
            maxHeight: 'none',
            objectFit: 'contain',
            objectPosition: onResolveBrandObjectPosition(config.appearance),
        },
        alt: config.alt,
        title: config.title,
        internalLink: config.internal_link,
        externalLink: config.external_link,
    };
};

/*
    UNICA FUENTE DE TAMANO:
    los cuatro slots de abajo se construyen directamente desde
    APP_SWITCH_APPEARANCE.BRAND. Si cambias height alli, se refleja en Core,
    navbar personalizado, Auth y footers sin tocar CSS.
*/
export const APP_BRAND_SLOTS = {
    headerPublic: onBuildBrandSlot(APP_SWITCH_APPEARANCE.BRAND.HEADER_PUBLIC),
    headerPrivate: onBuildBrandSlot(APP_SWITCH_APPEARANCE.BRAND.HEADER_PRIVATE),
    footerPublic: onBuildBrandSlot(APP_SWITCH_APPEARANCE.BRAND.FOOTER_PUBLIC),
    footerPrivate: onBuildBrandSlot(APP_SWITCH_APPEARANCE.BRAND.FOOTER_PRIVATE),
};

export const APP_BRAND_IDENTITY = {
    name: APP_COMPANY_CONFIG.COMPANY_NAME,
    claim: APP_COMPANY_CONFIG.COMPANY_CLAIM,
};
